import { MaterialModule } from './../../material.module';
import { SharedModule } from "src/app/shared/modules/shared.module";
import { TapPopOutChartComponent } from "./tap-pop-out-chart/tap-pop-out-chart.component";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TapPopOutCompareChartComponent } from "./tap-pop-out-compare-chart/tap-pop-out-compare-chart.component";
import {
  BarSeriesService,
  CategoryService,
  ChartAnnotationService,
  ChartModule,
  ColumnSeriesService,
  DataLabelService,
  DateTimeService,
  DateTimeCategoryService,
  LegendService,
  MultiLevelLabelService,
  RangeColumnSeriesService,
  ScrollBarService,
  SelectionService,
  StackingBarSeriesService,
  StackingColumnSeriesService,
  TooltipService,
  PieSeriesService,
  AccumulationLegendService,
  AccumulationTooltipService,
  AccumulationDataLabelService,
  AccumulationChartModule,
  StripLineService,
  MultiColoredLineSeriesService,
  LineSeriesService,
} from "@syncfusion/ej2-angular-charts";
import { TapChartComponent } from "./tap-chart.component";
import { TapDashboardChartComponent } from "./tap-dashboard-chart/tap-dashboard-chart.component";
import { ChartingService } from "./charting.service";
import { TankVolumeLevelChartComponent } from "./tank-volume-level-chart/tank-volume-level-chart.component";
import { TankVolumeGraphicComponent } from "./tank-volume-level-chart/tank-volume-graphic.component";
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TooltipModule } from 'ng2-tooltip-directive';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { TankDailyUsageChartComponent } from './tank-daily-usage-chart/tank-daily-usage-chart.component';
import { AgGridModule } from '@ag-grid-community/angular';
//import { CompareHistoricalDeliveryEfficiencyChartComponent } from 'src/app/widget/compare-historical-delivery-efficiency-chart/compare-historical-delivery-efficiency-chart.component';

@NgModule({
  declarations: [
    TapChartComponent,
    TapPopOutChartComponent,
    TapDashboardChartComponent,
    TankVolumeLevelChartComponent,
    TankVolumeGraphicComponent,
    TankDailyUsageChartComponent,
    TapPopOutCompareChartComponent,
    //CompareHistoricalDeliveryEfficiencyChartComponent
  ],
  imports: [CommonModule,
    ChartModule,
    AccumulationChartModule,
    MaterialModule,
    AngularSvgIconModule,
    TooltipModule,
    FlexLayoutModule,
    TranslateModule,
    AgGridModule
    ],
  exports: [
    ChartModule,
    AccumulationChartModule,
    TapChartComponent,
    TapPopOutChartComponent,
    TapDashboardChartComponent,
    TankVolumeLevelChartComponent,
    TankDailyUsageChartComponent,
    TapPopOutCompareChartComponent
  ],
  providers: [
    //Linear Charts
    CategoryService,
    LegendService,
    TooltipService,
    DataLabelService,
    BarSeriesService,
    StackingBarSeriesService,
    ColumnSeriesService,
    DateTimeService,
    DateTimeCategoryService,
    ScrollBarService,
    ChartAnnotationService,
    RangeColumnSeriesService,
    StackingColumnSeriesService,
    MultiLevelLabelService,
    SelectionService,
    //PIE Chart (Accumulation)
    PieSeriesService,
    AccumulationLegendService,
    AccumulationTooltipService,
    AccumulationDataLabelService,
    ChartingService,
    StripLineService,
    MultiColoredLineSeriesService,
    LineSeriesService,
  ],
})
export class ChartingModule {}
